import get from "lodash/get";
import { getCountry } from "../state/modules/config/selectors";
import commonConfig from "../config/common";
const { webContextKey } = commonConfig.globalKeys;

const getKsdvFromSiteChromeContext = () => {
  if (!CLIENT) {
    return;
  }

  const getKeyStoreDataversion = get(
    window,
    `${webContextKey}.getKeyStoreDataversion`,
    () => {}
  );

  return getKeyStoreDataversion();
};

export default state =>
  getKsdvFromSiteChromeContext() || getCountry(state).keyStoreDataversion;
